/**
 * Browse mode panel content — the Cars list (the ONE CarsTab component,
 * also reused by TheaterMode's local Cars pane).
 *
 * Default row click = global jump to detail mode for that car; theater
 * passes `onSelectCar` to keep the selection local to the rail.
 */

import React from 'react';

import CarsTab from './CarsTab';
// type-only: avoids a runtime circular import (router renders the modes)
import type { ViewerController } from './ViewerModeRouter';

export const BrowseMode: React.FC<{
  c: ViewerController;
  onSelectCar?: (id: string) => void;
}> = ({ c, onSelectCar }) => (
  <CarsTab
    devices={c.filtered}
    liveCount={c.liveCount}
    replay={c.replay}
    density={c.density}
    onDensityChange={c.setDensity}
    selectedId={c.selected?.device_id ?? null}
    onSelect={onSelectCar ?? ((id) => c.selectCar(id))}
    lagFor={c.lagFor}
    followedIds={c.followedIds}
    standings={c.standings}
    stageSel={
      c.selectedStage != null && c.selectedStageLabel != null
        ? {
            label: c.selectedStageLabel,
            has: (id) => c.stageSessionByDevice.has(id),
            // M4 posters — the stage-attributed session's frame.
            sessionFor: (id) => c.stageSessionByDevice.get(id),
          }
        : null
    }
  />
);

export default BrowseMode;
